<template>
  <vs-popup :active.sync="popupActive" :title="$t('ptos.ptoRequest')" class="holamundo" id="ptoApprovalModal">
    <div v-if="ptoData">
      <div class="leading-loose">
        <div class="flex">
          <div class="flex-1 flex mx-2">
            <span class="font-semibold">{{$t('users.table.name')}}:</span><span
            class="ml-1">{{ ptoData.user.name }}</span>
          </div>
          <div class="flex-1 flex mx-2">
            <span class="font-semibold">{{$t('users.table.surname')}}:</span><span class="ml-1">{{ ptoData.user.surname }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="flex-1 flex mx-2">
            <span class="font-semibold">{{$t('ptos.table.start_date')}}:</span><span class="ml-1">{{ ptoData.start_date | date }}</span>
          </div>
          <div class="flex-1 flex mx-2">
            <span class="font-semibold">{{$t('ptos.table.end_date')}}:</span><span class="ml-1">{{ ptoData.end_date | date }}</span>
          </div>
        </div>
        <div class="flex">
          <div class="flex-1 flex mx-2">
            <span class="font-semibold">{{$t('ptos.table.status')}}:</span>
            <vs-chip :color="applyColor(ptoData.status)" class="ml-1">{{ ptoData.status }}</vs-chip>
          </div>
          <div class="flex-1 flex mx-2">
            <span class="font-semibold">{{$t('users.table.email')}}:</span><a :href="`emailto:${ptoData.user.email}`"
                                                                              class="ml-1">{{ ptoData.user.email }}</a>
          </div>
        </div>
        <div class="flex flex-col mx-2">
          <span class="font-semibold">{{$t('ptos.table.notes')}}:</span>
          <span class="leading-normal">{{ ptoData.notes }}</span>
        </div>
      </div>
      <div class="flex justify-center mt-5" v-if="hasAccess">
        <base-button :disabled="!ptoData.can_approve" :loading="loading" @click="approvePto" button="filled" class="flex-1 px-3 mx-2"
                     color="success">
          <BaseIcon fixed-width name="check"/>
          {{$t('buttons.approve')}}
        </base-button>
        <base-button :disabled="!ptoData.can_reject" :loading="loading" @click="rejectPto" button="filled" class="flex-1 px-3 mx-2"
                     color="danger">
          <BaseIcon fixed-width name="ban"/>
          {{$t('buttons.reject')}}
        </base-button>
      </div>
    </div>
  </vs-popup>
</template>

<script>
  import Ptos from "../../services/Ptos";
  import Auth from "../../services/Auth";
  import {ADMIN_ROLE, HR_ROLE} from "../../middlewares/permissions";
  import EventBus from "../../utilities/eventBus";

  export default {
    name: "ptoApprovalModal",
    data: () => ({
      loading: false,
      popupActive: false,
      ptoData: null
    }),
    computed: {
      hasAccess () {
        let permittedRoles = [ADMIN_ROLE, HR_ROLE]
        return Auth.hasOneOfRoles(permittedRoles)
      }
    },
    methods: {
      show (pto) {
        this.popupActive = true;
        this.ptoData = pto
      },
      hide () {
        this.ptoData = null;
        this.popupActive = false
      },
      approvePto () {
        this.loading = true;
        Ptos.approve(this.ptoData.id).then(() => {
          this.$notificationService.success(`${this.$t('ptos.pto')} ${this.$t('notification.successApprove')}`);
          this.popupActive = false;
          EventBus.$emit('ptoStatusChange')
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loading = false;
        })
      },
      rejectPto () {
        this.loading = true;
        Ptos.reject(this.ptoData.id).then(() => {
          this.$notificationService.success(`${this.$t('ptos.pto')} ${this.$t('notification.successReject')}`);
          this.popupActive = false;
          EventBus.$emit('ptoStatusChange')
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loading = false;
        })
      },
      applyColor (status) {
        switch (status) {
          case 'PENDING':
            return 'warning';
          case 'APPROVED':
            return 'success';
          case 'REJECTED':
            return 'danger';
          default:
            return null
        }
      }
    },
    mounted () {
      EventBus.$on('ptoDetails', (pto) => this.show(pto))
    },
    beforeDestroy() {
      EventBus.$off('ptoDetails', (pto) => this.show(pto))
    }
  }
</script>

<style scoped>

</style>
